import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { CheckPermissionApi, CheckPermissionComponent } from '../../util/permission';
import {
    TICKET_LIST_ALL_REDMINE_UPDATE,
    TICKET_LIST_ALL_REDMINE_UPDATE_ASSIGNEE,
    TICKET_LIST_SOLUTION_REDMINE_UPDATE,
    TICKET_LIST_SOLUTION_REDMINE_UPDATE_ASSIGNEE
} from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import API_SOLUTION from '../../api/apiSolution';
import IconInfo from '../../assets/icons/IconInfo';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketRedmine extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showRedmineModal: false,
            redmineNumber: '',
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
        this.inputRef = React.createRef();
    }

    handleCopy = () => {
        this.inputRef.current.select();
        this.inputRef.current.setSelectionRange(0, 99999);
        document.execCommand("copy");
        alert("Copied the text: " + this.inputRef.current.value);
    }

    handleOpen = () => {
        this.setState({
            redmineNumber: this.props.data.no_redmine,
            showRedmineModal: true
        })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = e => {
        e.preventDefault();

        const data = {
            no_redmine: this.state.redmineNumber,
            updated_at: this.props.data.updated_at
        }

        if (this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS || this.props.data.status === STATUS_TICKET_CONSTANT.ON_HOLD) {
            API_TICKET_LIST.putDataRedmine(data, this.props.data.id, this.props.token)
                .then(res => {
                    this.setState({
                        showSuccessAlert: true,
                        showRedmineModal: false
                    })
                    setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                    this.props.refresh();
                }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                    this.setState({
                        errorMessage: getErrorMessage(err),
                        showErrorAlertResponse: true
                    })
                }))
        }
        if (this.props.data.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION) {
            API_SOLUTION.putDataRedmine(data, this.props.data.id, this.props.token)
                .then(res => {
                    this.setState({
                        showSuccessAlert: true,
                        showRedmineModal: false
                    })
                    setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                    this.props.refresh();
                }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                    this.setState({
                        errorMessage: getErrorMessage(err),
                        showErrorAlertResponse: true
                    })
                }))
        }
    }

    redmineReadOnly = () => {
        if (!this.checkPermissionRedmine() || !this.checkCustomerServiceAssignee()) {
            return (
                <div className="flex flex-row-reverse items-center">
                    <button type="button" id="btnclose" className="bg-lightblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.setState({ showRedmineModal: false })}>Tutup</button>
                    <button type="button" id="btncopy" className="bg-darkblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.handleCopy()}>Copy</button>
                </div>
            )
        }
        return null
    }

    checkPermissionRedmine = () => {
        if ((CheckPermissionApi(TICKET_LIST_ALL_REDMINE_UPDATE, this.props.userDetail.permissions)
            || CheckPermissionApi(TICKET_LIST_ALL_REDMINE_UPDATE_ASSIGNEE, this.props.userDetail.permissions))
            && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            return true
        }
        if ((CheckPermissionApi(TICKET_LIST_SOLUTION_REDMINE_UPDATE, this.props.userDetail.permissions)
            || CheckPermissionApi(TICKET_LIST_SOLUTION_REDMINE_UPDATE_ASSIGNEE, this.props.userDetail.permissions))
            && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            return true
        }
        return false
    }

    checkStatusTicket = () => {
        if (this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS) return true
        if (this.props.data.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION) return true
        return false
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false
        return true
    }

    render() {
        return (
            <>
                <button type="button" id="btnredmine" className={this.checkStatusTicket() ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1" : "hidden"} onClick={() => this.handleOpen()}>
                    <IconInfo />
                    <span className="ml-1">No Bug</span>
                </button>

                <div className={this.state.showRedmineModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/3">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnredmineclose" onClick={() => this.setState({ showRedmineModal: false })} />
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <p className="text-darkblue text-center text-3xl font-medium">No Bug</p>
                                <textarea id="tmlredminenumber" className="form-control resize-none text-2xl text-darkblue h-40 my-5" placeholder="Masukan No Bug" name="redmineNumber" ref={this.inputRef} value={this.state.redmineNumber} onChange={this.handleChange} maxLength="256" disabled={!this.checkPermissionRedmine() || !this.checkCustomerServiceAssignee()} />
                                <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_REDMINE_UPDATE, TICKET_LIST_ALL_REDMINE_UPDATE_ASSIGNEE, TICKET_LIST_SOLUTION_REDMINE_UPDATE, TICKET_LIST_SOLUTION_REDMINE_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                                    <div className={this.checkPermissionRedmine() && this.checkCustomerServiceAssignee() ? "flex justify-between items-center" : "hidden"}>
                                        <div>
                                            <button type="submit" id="btnsave" className="bg-darkblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3 mr-2">Ubah Nomor</button>
                                            <button type="button" id="btncopy" className="bg-darkblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.handleCopy()}>Copy</button>
                                        </div>
                                        <button type="button" id="btnclose" className="bg-lightblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.setState({ showRedmineModal: false })}>Tutup</button>
                                    </div>
                                </CheckPermissionComponent>
                                <this.redmineReadOnly />
                            </form>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketRedmine);